import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TranslationSelectorService} from '../shared/translation-selector.service';

export class LanguageInterceptor implements HttpInterceptor {
  constructor(
    private translationSelectorService: TranslationSelectorService
  ) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const langReq = req.clone({
      headers: req.headers.set('Accept-Language', this.translationSelectorService.getSelectedLanguage())
    });

    return next.handle(langReq);
  }
}
